import { Box, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

const logos = [
  { name: 'New York Times', src: '/marketing/logos/new-york-times-logo-light.png', slug: 'new-york-times' },
  { name: 'Time', src: '/marketing/logos/time-logo-light.png', slug: 'time' },
  { name: 'Lifehacker', src: '/marketing/logos/life-hacker-logo-light.png', slug: 'lifehacker' },
  { name: 'Forbes', src: '/marketing/logos/forbes-logo-light.png', slug: 'forbes' },
  { name: 'Slate', src: '/marketing/logos/slate-logo-light.png', slug: 'slate' },
];

export const PressLogos = () => {
  return (
    <Box
      sx={{
        py: 4,
        bgcolor: 'grey.900',
      }}
    >
      <Stack
        direction="row"
        spacing={{ xs: 3, md: 6 }}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        sx={{ gap: { xs: 2, md: 4 } }}
      >
        {logos.map((logo) => (
          <Link key={logo.name} to={`/press/${logo.slug}`}>
            <Box
              component="img"
              src={logo.src}
              alt={logo.name}
              sx={{
                height: { xs: 24, md: 32 },
                opacity: 0.7,
                filter: 'grayscale(100%)',
                transition: 'opacity 0.2s',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 1,
                },
              }}
            />
          </Link>
        ))}
      </Stack>
    </Box>
  );
};
